import type { LoginDto, RefreshTokenDto, TokenResponse, UserResponse } from '@tixbase/contracts';
import { baseApi } from '@/app/baseApi';
import { signedIn } from './authSlice';
import { tokenStorage } from './tokenStorage';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<TokenResponse, LoginDto>({
      query: (body) => ({ url: 'auth/login', method: 'POST', body }),
      extraOptions: { auth: 'none' },
      async onQueryStarted(_body, { dispatch, queryFulfilled }) {
        try {
          const { data: { accessToken, refreshToken } } = await queryFulfilled;
          tokenStorage.set({ accessToken: accessToken, refreshToken: refreshToken });
          dispatch(signedIn());
        } catch {
          //
        }
      },
    }),

    logout: builder.mutation<void, RefreshTokenDto>({
      query: (body) => ({ url: 'auth/logout', method: 'POST', body, timeout: 5000 }),
      extraOptions: { auth: 'none' },
    }),

    getCurrentUser: builder.query<UserResponse, void>({
      query: () => 'auth/me',
      providesTags: ['CurrentUser'],
    }),
  }),
});

export const { useLoginMutation, useLogoutMutation, useGetCurrentUserQuery } = authApi;
